export const PERMISSIONCATEGORY_LOADING = "PERMISSIONCATEGORY_LOADING";
export const PERMISSIONCATEGORY_RESET = "PERMISSIONCATEGORY_RESET";
export const GET_PERMISSIONCATEGORY = "GET_PERMISSIONCATEGORY";
export const GET_PERMISSIONCATEGORY_SUCCESS = "GET_PERMISSIONCATEGORY_SUCCESS";
export const GET_PERMISSIONCATEGORY_FAIL = "GET_PERMISSIONCATEGORY_FAIL";
export const DELETE_PERMISSIONCATEGORY = "DELETE_PERMISSIONCATEGORY"
export const DELETE_PERMISSIONCATEGORY_SUCCESS = "DELETE_PERMISSIONCATEGORY_SUCCESS"
export const DELETE_PERMISSIONCATEGORY_FAIL = "DELETE_PERMISSIONCATEGORY_FAIL"
export const UPDATE_PERMISSIONCATEGORY = "UPDATE_PERMISSIONCATEGORY"
export const UPDATE_PERMISSIONCATEGORY_SUCCESS = "UPDATE_PERMISSIONCATEGORY_SUCCESS"
export const UPDATE_PERMISSIONCATEGORY_FAIL = "UPDATE_PERMISSIONCATEGORY_FAIL"
export const ADD_NEW_PERMISSIONCATEGORY = "ADD_NEW_PERMISSIONCATEGORY"
export const ADD_PERMISSIONCATEGORY_SUCCESS = "ADD_PERMISSIONCATEGORY_SUCCESS"
export const ADD_PERMISSIONCATEGORY_FAIL = "ADD_PERMISSIONCATEGORY_FAIL"